import React, { useState } from 'react';
import useAvalaraSettingsState from './hooks/useAvalaraSettingsState';
import { message } from 'antd';
import AvalaraSettingsList from './components/avalaraSettingList';
import AvalaraSettingsModal from './components/avalaraSettingModal';

const AvalaraSettings = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const { avalaraSettings, loading, addOrUpdate, activateSetting } = useAvalaraSettingsState();

  const [modalOpen, setModalOpen] = useState(false);
  const [editingSetting, setEditingSetting] = useState(null);

  const handleAdd = () => {
    setEditingSetting(null);
    setModalOpen(true);
  };

  const handleEdit = (setting) => {
    setEditingSetting(setting);
    setModalOpen(true);
  };

  const handleSave = async (setting) => {
    const response = await addOrUpdate(setting);
    if (response?.success) {
      setModalOpen(false);
      let toastMessage = 'Avalara setting created successfully';
      if (editingSetting && editingSetting.id) {
        toastMessage = 'Avalara setting updated successfully';
      }
      messageApi.success(toastMessage, 5);
    }
    return response;
  };

  const handleActivate = async (id) => {
    await activateSetting(id);
  };

  return (
    <>
      {contextHolder}
      <AvalaraSettingsList
        setting={avalaraSettings}
        loading={loading}
        onEdit={handleEdit}
        markActive={handleActivate}
        onAdd={handleAdd}
      />
      <AvalaraSettingsModal
        visible={modalOpen}
        onCancel={() => setModalOpen(false)}
        onSave={handleSave}
        initialData={editingSetting}
      />
    </>
  );
};

export default AvalaraSettings;
